module.exports = __webpack_public_path__ + "img/trips-2-mobile.633c0120.gif";